import fetchApi from './api';
import fetchApiBlob from './apiBlob';
import {ApiResponse, LoginResponse, SearchPaging, Document} from 'models/model';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';


export const DocumentUpload = async (data: any): Promise<ApiResponse> => {
    const formData = new FormData();

    if (data.id) formData.append('Id', data.id);
    formData.append('CourseId', data.courseId);
    formData.append('Type', data.type);
    formData.append('Name', data.name);
    formData.append('File', data.file);

    return fetchApi<any>(`/Document/Upload`, {
        method: 'POST',
        body: formData,
    });
};



// Mới nhất

export const DocumentGetRoot = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/GetRootFolder', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const DocumentListFolder = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/ListFolder', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const DocumentCreateFolder = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/CreateFolder', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const DocumentUploadFile = async (data: any): Promise<ApiResponse> => {
    const formData = new FormData();
    formData.append('CourseId', data.courseId);
    formData.append('Name', data.name);
    formData.append('TargetPath', data.targetPath);
    formData.append('File', data.file);

    return fetchApi<ApiResponse>('/Document/UploadFile', {
        method: 'POST',
        body: formData,
    });
}

export async function DocumentDownloadFile(data: any) : Promise<Blob> {
    return fetchApiBlob<Blob>('/Document/DownloadFile', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/octet-stream'
        },
    });
}

export const DocumentRename = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/RenameFolderOrFile', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const DocumentDeleteFolder = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/DeleteFolderOrFile', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const DocumentMove = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/MoveFolderOrFile', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const DocumentGetLessonPlanRoot = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/GetLessonPlanRootFolder', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const DocumentGetDecisionRoot = async (): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Document/GetDecisionRootFolder', {
        method: 'POST',
        body: JSON.stringify({})
    });
};